module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "fill": "none",
      "height": "53",
      "viewBox": "0 0 53 53",
      "width": "53",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "26.5",
      "cy": "26.5",
      "fill": "#F6F5F5",
      "r": "26.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.085 9.48054L18.5704 7.99512H34.9101L37.1382 10.2233V43.6453L34.9101 45.1308H19.3131L17.085 43.6453V9.48054Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.1341 25.4619H24.626V27.2667H29.1341V25.4619Z",
      "fill": "#F5103B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.5312 27.2662V25.4619H25.9829L25.5312 27.2662Z",
      "fill": "#5C0617",
      "opacity": "0.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.2348 27.2662V25.4619H27.7832L28.2348 27.2662Z",
      "fill": "#5C0617",
      "opacity": "0.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.0368 24.1069V28.8034C30.0369 28.8842 30.0156 28.9637 29.9751 29.0336C29.9345 29.1036 29.8762 29.1616 29.8061 29.2017L28.4671 29.9675C28.4435 29.9816 28.4165 29.989 28.389 29.9892C28.3615 29.9893 28.3345 29.9821 28.3107 29.9683C28.287 29.9544 28.2673 29.9345 28.2538 29.9106C28.2403 29.8866 28.2334 29.8595 28.2338 29.832V24.1069C28.2343 23.7544 28.0972 23.4155 27.8517 23.1626C27.6063 22.9096 27.2718 22.7625 26.9196 22.7525C26.5674 22.7426 26.2253 22.8706 25.966 23.1093C25.7067 23.348 25.5507 23.6786 25.5312 24.0307C25.5312 24.0121 25.5312 23.9936 25.5312 23.975C25.5337 23.9386 25.5367 23.902 25.5405 23.8652C25.5405 23.8472 25.5446 23.8292 25.5467 23.8111L25.5544 23.7596C25.5575 23.7416 25.5601 23.724 25.5632 23.7081C25.5699 23.673 25.5771 23.6375 25.5848 23.6024C25.5889 23.5854 25.5936 23.5679 25.5977 23.5509C25.6018 23.5339 25.6064 23.5164 25.6116 23.4993C25.6167 23.4823 25.6214 23.4638 25.6276 23.4478C25.6337 23.4318 25.6373 23.4153 25.6425 23.3999C25.6687 23.3209 25.6995 23.2434 25.7347 23.168C25.7403 23.1546 25.747 23.1407 25.7537 23.1278C25.7604 23.1149 25.7599 23.1144 25.7635 23.1077C25.7712 23.0922 25.7795 23.0768 25.7872 23.0608C25.8308 22.9793 25.8791 22.9005 25.9319 22.8248C25.9473 22.8021 25.9633 22.7799 25.9793 22.7583C26.0424 22.6739 26.1112 22.594 26.1853 22.5191C26.4935 22.2106 26.8845 21.9982 27.3109 21.9076C27.7373 21.817 28.1808 21.8521 28.5877 22.0086C28.9945 22.1652 29.3473 22.4364 29.6032 22.7896C29.8592 23.1427 30.0073 23.5625 30.0296 23.9982C30.0363 24.0296 30.0368 24.0683 30.0368 24.1069Z",
      "fill": "url(#paint0_linear_897_703)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.0343 23.9913C30.012 23.5556 29.8639 23.1358 29.608 22.7827C29.3521 22.4295 28.9993 22.1583 28.5924 22.0017C28.1856 21.8452 27.742 21.8101 27.3156 21.9007C26.8892 21.9913 26.4982 22.2037 26.19 22.5123C26.116 22.5871 26.0472 22.667 25.9841 22.7514C25.9681 22.773 25.9521 22.7952 25.9367 22.8179C25.8839 22.8936 25.8355 22.9724 25.792 23.0539C25.7842 23.0699 25.776 23.0853 25.7683 23.1008C25.7647 23.1075 25.7616 23.1142 25.7585 23.1209L25.7492 23.1399C25.7112 23.2212 25.6776 23.3044 25.6488 23.3894C25.6426 23.4064 25.637 23.4239 25.6323 23.4409C25.6277 23.4579 25.621 23.477 25.6164 23.4925C25.6117 23.5079 25.6066 23.527 25.6025 23.544C25.5983 23.561 25.5932 23.579 25.5896 23.5955C25.5813 23.63 25.5741 23.6656 25.568 23.7012C25.5643 23.7192 25.5613 23.7367 25.5592 23.7527C25.5571 23.7687 25.5535 23.7883 25.5515 23.8042C25.5494 23.8202 25.5463 23.8403 25.5453 23.8584C25.5407 23.8944 25.5381 23.931 25.536 23.9681C25.536 23.9913 25.5335 24.014 25.5329 24.0377C25.5329 24.0434 25.5329 24.0495 25.5329 24.0557C25.5329 24.0707 25.5329 24.0856 25.5329 24.1001V29.8318C25.5334 29.8593 25.5265 29.8864 25.513 29.9104C25.4995 29.9343 25.4798 29.9543 25.456 29.9681C25.4323 29.9819 25.4052 29.9891 25.3777 29.989C25.3503 29.9888 25.3233 29.9814 25.2997 29.9673L23.9607 29.2015C23.8904 29.1615 23.832 29.1036 23.7914 29.0336C23.7507 28.9636 23.7294 28.8841 23.7295 28.8032V24.165C23.7295 22.4128 25.1596 20.9389 26.9079 20.9512C27.7206 20.9567 28.4998 21.276 29.0829 21.8425C29.666 22.4091 30.008 23.1791 30.0374 23.9918L30.0343 23.9913Z",
      "fill": "url(#paint1_linear_897_703)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.8774 32.675V34.3756C26.7626 34.3757 26.6496 34.3468 26.5489 34.2916L25.6322 33.768L22.8024 32.1493L21.4218 31.3598C21.2935 31.2864 21.187 31.1804 21.1129 31.0525C21.0388 30.9246 20.9999 30.7794 21 30.6316V21.8526C21 21.3742 21.1899 20.9154 21.5279 20.5771C21.8659 20.2389 22.3244 20.0488 22.8024 20.0488V30.3456L26.8774 32.675Z",
      "fill": "#F5103B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21.5279 20.5752C21.1899 20.9134 21 21.3722 21 21.8506H22.8024V20.0469C22.3244 20.0469 21.8659 20.2369 21.5279 20.5752Z",
      "fill": "url(#paint2_linear_897_703)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.7152 20.0488V30.6543C32.7154 30.802 32.6767 30.9472 32.6029 31.0751C32.5291 31.2031 32.4229 31.3093 32.295 31.383L30.9143 32.1715L28.6057 33.4923L27.207 34.2911C27.1061 34.3468 26.9927 34.3759 26.8774 34.3756V32.675L30.9128 30.3672V19.77C30.8464 19.3451 30.6304 18.958 30.3039 18.6784C29.9774 18.3988 29.5618 18.2451 29.132 18.2451H30.9128C31.3908 18.2451 31.8493 18.4352 32.1873 18.7734C32.5253 19.1117 32.7152 19.5705 32.7152 20.0488Z",
      "fill": "#F5103B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.2036 34.2861L28.6023 33.4873V31.6816L26.874 32.67V34.3707C26.9893 34.3709 27.1027 34.3418 27.2036 34.2861Z",
      "fill": "url(#paint3_linear_897_703)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.9133 19.7705V20.0498H22.8024C22.3244 20.0498 21.8659 20.2398 21.5279 20.5781C21.1899 20.9163 21 21.3751 21 21.8535V20.0498C21.0001 19.9578 21.007 19.866 21.0206 19.7751C21.0252 19.7452 21.0309 19.7153 21.0366 19.6859C21.0545 19.5983 21.079 19.5122 21.1097 19.4283C21.1195 19.4009 21.1303 19.3736 21.1416 19.3468C21.3257 18.9151 21.6697 18.5715 22.1015 18.3883C22.1278 18.3769 22.153 18.3661 22.1829 18.3563C22.2669 18.3258 22.3529 18.3013 22.4404 18.2831C22.4697 18.2775 22.4996 18.2723 22.529 18.2677C22.6198 18.254 22.7116 18.2471 22.8034 18.2471H29.1325C29.562 18.247 29.9774 18.4004 30.3039 18.6797C30.6304 18.959 30.8465 19.3458 30.9133 19.7705Z",
      "fill": "url(#paint4_linear_897_703)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.9119 20.0459V19.7668C30.8463 19.2985 30.5761 18.9039 30.2492 18.6249C29.9223 18.3459 29.5063 18.2451 29.0762 18.2451V20.0459H30.9119Z",
      "fill": "url(#paint5_linear_897_703)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.2066 41.4277H19.4691C19.3039 41.4277 19.1455 41.4934 19.0286 41.6102C18.9118 41.727 18.8462 41.8854 18.8462 42.0507C18.8462 42.2159 18.9118 42.3743 19.0286 42.4911C19.1455 42.6079 19.3039 42.6736 19.4691 42.6736H23.2066C23.3718 42.6736 23.5303 42.6079 23.6471 42.4911C23.7639 42.3743 23.8296 42.2159 23.8296 42.0507C23.8296 41.8854 23.7639 41.727 23.6471 41.6102C23.5303 41.4934 23.3718 41.4277 23.2066 41.4277Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.7034 41.4277H25.0804C24.9152 41.4277 24.7568 41.4934 24.64 41.6102C24.5231 41.727 24.4575 41.8854 24.4575 42.0507C24.4575 42.2159 24.5231 42.3743 24.64 42.4911C24.7568 42.6079 24.9152 42.6736 25.0804 42.6736H25.7034C25.8686 42.6736 26.027 42.6079 26.1438 42.4911C26.2607 42.3743 26.3263 42.2159 26.3263 42.0507C26.3263 41.8854 26.2607 41.727 26.1438 41.6102C26.027 41.4934 25.8686 41.4277 25.7034 41.4277Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M34.4231 6.5459H19.473C18.6472 6.54683 17.8556 6.87527 17.2717 7.45917C16.6878 8.04307 16.3593 8.83474 16.3584 9.6605V42.0524C16.3593 42.8781 16.6878 43.6698 17.2717 44.2537C17.8556 44.8376 18.6472 45.166 19.473 45.167H34.4231C35.2488 45.166 36.0405 44.8376 36.6244 44.2537C37.2083 43.6698 37.5368 42.8781 37.5377 42.0524V9.6605C37.5368 8.83474 37.2083 8.04307 36.6244 7.45917C36.0405 6.87527 35.2488 6.54683 34.4231 6.5459ZM31.1716 7.79174L30.7978 9.6605H23.0983L22.7246 7.79174H31.1716ZM36.2919 42.0524C36.2913 42.5478 36.0942 43.0228 35.7439 43.3732C35.3936 43.7235 34.9185 43.9206 34.4231 43.9211H19.473C18.9775 43.9206 18.5025 43.7235 18.1522 43.3732C17.8019 43.0228 17.6048 42.5478 17.6042 42.0524V9.6605C17.6048 9.16505 17.8019 8.69004 18.1522 8.3397C18.5025 7.98936 18.9775 7.7923 19.473 7.79174H21.454L21.9768 10.4056C22.005 10.5468 22.0813 10.6739 22.1927 10.7652C22.304 10.8565 22.4436 10.9063 22.5876 10.9063H31.3085C31.4525 10.9063 31.5921 10.8565 31.7034 10.7652C31.8148 10.6739 31.8911 10.5468 31.9193 10.4056L32.4421 7.79174H34.4231C34.9185 7.7923 35.3936 7.98936 35.7439 8.3397C36.0942 8.69004 36.2913 9.16505 36.2919 9.6605V42.0524Z",
      "fill": "#060606",
      "stroke": "#E8E7E5",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_897_703",
      "gradientUnits": "userSpaceOnUse",
      "x1": "27.5232",
      "x2": "24.3178",
      "y1": "25.4232",
      "y2": "23.5488"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F5103B"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7B081E"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_897_703",
      "gradientUnits": "userSpaceOnUse",
      "x1": "1095.57",
      "x2": "1077.71",
      "y1": "2365.44",
      "y2": "2939.96"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F5103B"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7B081E"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint2_linear_897_703",
      "gradientUnits": "userSpaceOnUse",
      "x1": "22.4686",
      "x2": "21.9205",
      "y1": "20.0469",
      "y2": "22.5028"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#B80B2C"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.7817",
      "stop-color": "#F5103B"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint3_linear_897_703",
      "gradientUnits": "userSpaceOnUse",
      "x1": "26.874",
      "x2": "29.0277",
      "y1": "33.5655",
      "y2": "32.7618"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#B80B2C"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.7817",
      "stop-color": "#F5103B"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint4_linear_897_703",
      "gradientUnits": "userSpaceOnUse",
      "x1": "2150.67",
      "x2": "2947.46",
      "y1": "345.783",
      "y2": "295.815"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F5103B"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7B081E"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint5_linear_897_703",
      "gradientUnits": "userSpaceOnUse",
      "x1": "30.6409",
      "x2": "28.9188",
      "y1": "18.8701",
      "y2": "19.8011"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#B80B2C"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.743839",
      "stop-color": "#F5103B"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a80bb6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/icons/AkkoPlanIcon.vue
// module id = 764
// module chunks = 0